import { render, staticRenderFns } from "./ClassPassButton.vue?vue&type=template&id=44946c6b&"
import script from "./ClassPassButton.vue?vue&type=script&lang=js&"
export * from "./ClassPassButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports